import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { deleteTableIcon, listTableIcons, uploadTableIcon, type TableIcon, type TableIconList } from "../services/adminTableIcons";

const iconsKey = (orgId?: number | null) => ["admin", "table-icons", orgId ?? "own"] as const;

/** The icon library for an org: its own uploads plus the shared read-only set. */
export const useTableIcons = (orgId?: number | null, enabled = true) =>
  useQuery<TableIconList>({
    queryKey: iconsKey(orgId),
    queryFn: () => listTableIcons(orgId),
    enabled
  });

export const useUploadTableIcon = (orgId?: number | null) => {
  const queryClient = useQueryClient();
  return useMutation<TableIcon, unknown, File>({
    mutationFn: (file: File) => uploadTableIcon(file, orgId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: iconsKey(orgId) })
  });
};

export const useDeleteTableIcon = (orgId?: number | null) => {
  const queryClient = useQueryClient();
  return useMutation<{ deleted: string }, unknown, string>({
    mutationFn: (path: string) => deleteTableIcon(path, orgId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: iconsKey(orgId) })
  });
};
